// ── MessageSellerModal.jsx ────────────────────────────────────────────────────
// Sub-modal: send a message to the seller

import React from 'react';
import styles from '../ProductDetailModal.module.css';

const MessageSellerModal = ({
  product,
  messageText,
  setMessageText,
  messageError,
  setMessageError,
  isSubmittingMessage,
  onSubmit,
  onClose,
}) => {
  return (
    <div
      className={styles.offerModalOverlay}
      onClick={() => !isSubmittingMessage && onClose()}
    >
      <div className={styles.offerModal} onClick={(e) => e.stopPropagation()}>
        <button
          className={styles.offerCloseBtn}
          onClick={onClose}
          disabled={isSubmittingMessage}
        >
          ×
        </button>

        <h3>Message Seller</h3>
        <p className={styles.offerModalSubtitle}>
          Regarding: <strong>{product.name}</strong>
        </p>

        {messageError && <div className={styles.errorBanner}>{messageError}</div>}

        <div className={styles.offerInputGroup}>
          <label>Your Message</label>
          <textarea
            className={styles.offerTextarea}
            placeholder="Type your message here..."
            value={messageText}
            onChange={(e) => {
              setMessageText(e.target.value);
              if (messageError) setMessageError('');
            }}
            rows="5"
            disabled={isSubmittingMessage}
          />
          <small style={{ color: '#9ca3af', fontSize: '11px' }}>
            {messageText.length}/1000 characters
          </small>
        </div>

        <div className={styles.offerModalButtons}>
          <button
            className={styles.offerSubmitBtn}
            onClick={onSubmit}
            disabled={isSubmittingMessage}
          >
            {isSubmittingMessage ? 'Sending...' : 'Send Message'}
          </button>
          <button
            className={styles.offerCancelBtn}
            onClick={onClose}
            disabled={isSubmittingMessage}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageSellerModal;
